"use client";
import CustomLink from "@/app/components/CustomLink";
import Image from "next/image";
import React from "react";
import { useRouter } from "next/router";

interface ProductCardProps {
	imageSrc: string;
	logoSrc: string;
	altText: string;
	carLink: string;
}

const ProductCard: React.FC<ProductCardProps> = ({
	imageSrc,
	logoSrc,
	altText,
	carLink,
}) => {
	const router = useRouter();

	const handleNavigate = () => {
		router.push(carLink);
	};

	const handleKeyDown: React.KeyboardEventHandler<HTMLElement> = (event) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			handleNavigate();
		}
	};
	return (
		<article
			className="flex flex-col grow justify-center py-4 text-sm transition-all duration-500 text-center uppercase text-zinc-800 mt-10 hover:mt-0 max-md:mt-6 cursor-pointer"
			onClick={handleNavigate}
			onKeyDown={handleKeyDown}
			role="link"
			tabIndex={0}
			aria-label={altText}
		>
			<div
				className="flex relative shadow-xl shadow-transparent transition-all duration-500 hover:shadow-black/30 flex-col rounded-xl overflow-y-hidden items-center pt-6 pb-3.5 w-full aspect-[0.8] "
				style={{
					backgroundImage: `url('${imageSrc}')`,
					backgroundPosition: "center center",
					backgroundSize: "cover",
				}}
			>
				<div className="w-full py-4 relative flex flex-col items-center transition-all duration-500 justify-between h-full hover:pb-24">
					<img
						width={400}
						height={400}
						loading="lazy"
						src={logoSrc}
						alt={altText}
						className="aspect-[7.14] w-[267px] rounded-md"
					/>
					<CustomLink
						href={carLink}
						className="relative -mb-20 bg-white px-5 py-2 rounded"
						onClick={(e) => e.stopPropagation()}
					>
						SAIBA MAIS
					</CustomLink>
				</div>
			</div>
		</article>
	);
};

export default ProductCard;
